module.exports = __webpack_public_path__ + "static/media/focus.49dd97ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S厢式车/focus.png
// module id = 718
// module chunks = 0